import { render, staticRenderFns } from "./detailPreviewPopup.vue?vue&type=template&id=16aae43c&scoped=true&"
import script from "./detailPreviewPopup.vue?vue&type=script&lang=js&"
export * from "./detailPreviewPopup.vue?vue&type=script&lang=js&"
import style0 from "./detailPreviewPopup.vue?vue&type=style&index=0&id=16aae43c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16aae43c",
  null
  
)

export default component.exports